import updateDocumentField from 'api/v2/repository/updateDocumentField';
import useMutation from 'hooks/react-query/useMutation';
import useQueryClient from 'hooks/react-query/useClientQuery';

import { DocumentsRepositoryCacheKeys } from 'types/cacheKeys.types';
import type { DocumentReferenceField } from 'types/repository.types';

const useUpdateDocumentField = (documentId: string) => {
  const queryClient = useQueryClient();

  const onSuccessCallback = (documentField: DocumentReferenceField) => {
    queryClient.invalidateQueries([
      DocumentsRepositoryCacheKeys.DocumentFields,
      documentId,
    ]);
  };

  return useMutation({
    mutationFn: (documentField: Partial<DocumentReferenceField>) =>
      updateDocumentField(documentId, documentField),
    onSuccess: ({ data: documentField }) => onSuccessCallback(documentField),
  });
};

export default useUpdateDocumentField;
